<div
  #dragSurface
  class="drag-surface block w-full h-full bg-transparent"
  nrcDoubleClick
  nrcClickOutside
  [targetContainerElement]="viewerElement"
  (doubleClickEvent)="onDoubleClick($event)"
  (singleClickEvent)="onClick($event)"
  (clickOutsideEvent)="onClickOutside($event)"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerEnd()"
  (pointerleave)="onPointerEnd()">
</div>
